import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-card" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = ["type"]
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/useAuthStore'

interface LoginData {
  username: string
  password: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter()
const authStore = useAuthStore()

const loginData = reactive<LoginData>({
  username: '',
  password: ''
})

const loading = ref<boolean>(false)
const error = ref<string>('')
const showPassword = ref<boolean>(false)

const togglePasswordVisibility = (): void => {
  showPassword.value = !showPassword.value
}

const handleLogin = async (): Promise<void> => {
  loading.value = true
  error.value = ''

  try {
    await authStore.login(loginData)
    router.push('/')
  } catch (err: any) {
    error.value = err.response?.data?.detail || 'Error al iniciar sesión. Verifica tus credenciales.'
    console.error('Login error:', err)
  } finally {
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "login-header" }, [
        _createElementVNode("i", { class: "fas fa-shipping-fast logo" }),
        _createElementVNode("h1", null, "Sistema de Gestión"),
        _createElementVNode("p", null, "Control de Stock y Envíos")
      ], -1)),
      _createElementVNode("form", {
        onSubmit: _withModifiers(handleLogin, ["prevent"]),
        class: "login-form"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "username" }, "Usuario", -1)),
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-user input-icon" }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              id: "username",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginData.username) = $event)),
              type: "text",
              class: "form-input",
              placeholder: "Ingresa tu usuario",
              required: "",
              autocomplete: "username"
            }, null, 512), [
              [_vModelText, loginData.username]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { for: "password" }, "Contraseña", -1)),
          _createElementVNode("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-lock input-icon" }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              id: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginData.password) = $event)),
              type: showPassword.value ? 'text' : 'password',
              class: "form-input",
              placeholder: "Ingresa tu contraseña",
              required: "",
              autocomplete: "current-password"
            }, null, 8, _hoisted_7), [
              [_vModelDynamic, loginData.password]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "password-toggle",
              onClick: togglePasswordVisibility
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(showPassword.value ? 'fas fa-eye-slash' : 'fas fa-eye')
              }, null, 2)
            ])
          ])
        ]),
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(error.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "submit",
          class: "login-btn",
          disabled: loading.value
        }, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1),
                _createTextVNode(" Iniciando sesión... ")
              ])))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, _cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "fas fa-sign-in-alt" }, null, -1),
                _createTextVNode(" Iniciar Sesión ")
              ])))
        ], 8, _hoisted_9)
      ], 32),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "login-footer" }, [
        _createElementVNode("p", null, "Sistema de gestión interna")
      ], -1))
    ])
  ]))
}
}

})